import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';

const ItemsTabs = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="py-2">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S No.</th>
                                    <th>Product Name</th>
                                    <th>Product Desc</th>
                                    <th>HSN</th>
                                    <th>Qty</th>
                                    <th>Gross Wt.</th>
                                    <th>Prod Value</th>
                                    <th>CGST</th>
                                    <th>SGST</th>
                                    <th>IGST</th>
                                    <th>CESS</th>
                                    <th>CESSNonAdvol</th>

                                    
                                </tr>
                            </thead>
                            <tbody>
                           
                            <tr>
            <td colSpan='2'>Total(NR): 0.00</td>
            <td>Taxable Amt: 0.00</td>
            <td>CGST Amt: 0.00</td>
            <td>SGST Amt: 0.00</td>
            <td>IGST Amt: 0.00</td>
            <td>CESS Amt: 0.00</td>
            <td>NonAdvol Amt: 0.00</td>
            <td>Tax: 0.00</td>
            <td>Oth Amt: 0.00</td>
        </tr>
      
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        <div className="row">
    {/* Sr No */}
    <div className="col-md-3 mt-2">
        <label htmlFor="srNo" className="form-label mb-0">Sr No</label>
        <input type="text" id="srNo" className="form-control form-control-sm w-100" value="0" readOnly />
    </div>

    {/* Product Name */}
    <div className="col-md-3 mt-2">
        <label htmlFor="productName" className="form-label mb-0">Product Name</label>
        <input type="text" id="productName" className="form-control form-control-sm w-100" />
    </div>

    {/* Product Desc */}
    <div className="col-md-3 mt-2">
        <label htmlFor="productDesc" className="form-label mb-0">Product Desc</label>
        <input type="text" id="productDesc" className="form-control form-control-sm w-100" />
    </div>

    {/* HSN */}
    <div className="col-md-3 mt-2">
        <label htmlFor="hsn" className="form-label mb-0">HSN</label>
        <input type="text" id="hsn" className="form-control form-control-sm w-100" />
    </div>

    {/* Quantity */}
    <div className="col-md-3 mt-2">
        <label htmlFor="quantity" className="form-label mb-0">Quantity</label>
        <input type="text" id="quantity" className="form-control form-control-sm w-100" value="0" />
    </div>

    {/* Pkgs */}
    <div className="col-md-3 mt-2">
        <label htmlFor="pkgs" className="form-label mb-0">Pkgs</label>
        <input type="text" id="pkgs" className="form-control form-control-sm w-100" value="0" />
    </div>

    {/* Gross Wt */}
    <div className="col-md-3 mt-2">
        <label htmlFor="grossWt" className="form-label mb-0">Gross Wt</label>
        <input type="text" id="grossWt" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* Prod Value */}
    <div className="col-md-3 mt-2">
        <label htmlFor="prodValue" className="form-label mb-0">Prod Value</label>
        <input type="text" id="prodValue" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* CGST */}
    <div className="col-md-3 mt-2">
        <label htmlFor="cgst" className="form-label mb-0">CGST</label>
        <input type="text" id="cgst" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* SGST */}
    <div className="col-md-3 mt-2">
        <label htmlFor="sgst" className="form-label mb-0">SGST</label>
        <input type="text" id="sgst" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* IGST */}
    <div className="col-md-3 mt-2">
        <label htmlFor="igst" className="form-label mb-0">IGST</label>
        <input type="text" id="igst" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* CESS */}
    <div className="col-md-1 mt-2">
        <label htmlFor="cess" className="form-label mb-0">CESS</label>
        <input type="text" id="cess" className="form-control form-control-sm w-100" value="0.00" />
    </div>

    {/* CESS Non Advol */}
    <div className="col-md-2 mt-2">
        <label htmlFor="cessNonAdvol" className="form-label mb-0">CESS Non Advol</label>
        <input type="text" id="cessNonAdvol" className="form-control form-control-sm w-100" value="0.00" />
    </div>

</div>

        <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    New
                </button>
                <button className="btn btn-primary text-xs" type="button" >
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Delete
                </button>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="button">
                Close
            </button>
        </div>
    </form>

    <Offcanvas show={showAdd} onHide={handleCloseAdd} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Item Dtls(New)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Product Code</label>
                    <input type="text" className="form-control form-control-sm w-100" placeholder="" />
                </div>
                <div className="col-md-12">
                    <label className="form-label">Product Name</label>
                    <input type="text" className="form-control form-control-sm w-100" placeholder="" />
                </div>
           

                <div className="col-md-12">
                    <label className="form-label">Goods Line</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Quantity</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="NOS" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Rate</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="KGs" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Amount</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Country of Origin </label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label className="form-label">Manufacturer</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control form-control-sm w-100 mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Invoice No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm w-100 custom-selector w-100" />
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Submit
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseAdd}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>

    <Offcanvas show={showEdit} onHide={handleCloseEdit} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Item Dtls(Edit)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Product Code</label>
                    <input type="text" className="form-control form-control-sm w-100" placeholder="" />
                </div>
                <div className="col-md-12">
                    <label className="form-label">Product Name</label>
                    <input type="text" className="form-control form-control-sm w-100" placeholder="" />
                </div>
             

                <div className="col-md-12">
                    <label className="form-label">Goods Line</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Quantity</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="NOS" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Rate</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="KGs" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Amount</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm w-100" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Country of Origin </label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label className="form-label">Manufacturer</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control form-control-sm w-100 mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Invoice No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm w-100 custom-selector w-100" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseEdit}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>
</>
);
};

export default ItemsTabs;